interface DepartmentBadgeProps {
  dept?: string;
}

export default function DepartmentBadge({ dept }: DepartmentBadgeProps) {
  function renderStyles() {
    const _dept = dept?.toLowerCase();
    switch (_dept) {
      case 'design':
        return 'border-[#5E7F21] bg-[#475925]';

      case 'data':
        return 'border-[#DD9108] bg-[#8F5D04]';

      case 'backend engineering':
        return 'border-[#2E59BB] bg-[#213D7C] ';
      case 'frontend engineering':
        return 'border-[#0CAAAF] bg-[#164C3B] ';
      case 'product':
        return 'border-[#E22E89] bg-[#803259]';

      default:
        return 'border-modal-stroke';
    }
  }
  return (
    <div
      className={`${renderStyles()} ${dept ? 'text-text-primary-heading' : ''} font-semibold capitalize text-[10px] xl:text-[12px] flex items-center gap-1 px-2  border-0.5 rounded-md whitespace-nowrap`}
    >
      <div className="w-3 h-3">
        <DeptIcon />
      </div>

      {dept}
    </div>
  );
}

export function DeptIcon() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.84135 3.31249C7.85802 4.32915 7.85802 5.97914 6.84135 6.99581C5.82469 8.01247 4.17467 8.01247 3.15801 6.99581C2.14134 5.97914 2.14134 4.32915 3.15801 3.31249C4.17467 2.29582 5.82469 2.29582 6.84135 3.31249Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.43725 9.01668C2.60392 8.68335 1.87475 8.07918 1.39142 7.24168C0.916419 6.42085 0.758085 5.50835 0.870585 4.63751"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.4375 1.86667C3.14583 1.3125 4.03333 0.983337 5 0.983337C5.94583 0.983337 6.81667 1.30417 7.51667 1.8375"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.5625 9.01668C7.39583 8.68335 8.125 8.07918 8.60834 7.24168C9.08334 6.42085 9.24167 5.50835 9.12917 4.63751"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
